function addLike({ contentId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/likes`;
  return apiClient.post(route, { contentId });
}

function removeLike({ contentId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/likes`;
  return apiClient.delete(route, { contentId });
}

export default { addLike, removeLike };
